import { IconButton } from "../IconButton/IconButton";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { styled } from "@mui/material";
import { openWindow } from "src/redux/actions/Mosaic.Actions";
import { useDispatch } from "react-redux";

interface IOpenPairingSummaryProps {
  shortId?: string;
  pairingId?: string;
  crewId?: string;
  path?: string[];
  isBidPairing?: boolean; // special spapshot of pairing that can be loaded into the summary handlebars.
}

const OCOpenPairingSummary = styled(IconButton)(({ theme }) => ({
  color: theme.custom.forms.labels,
  padding: 0,
  paddingLeft: 5,
  margin: 5,
  borderRadius: 3,
  fontSize: 12,
  textAlign: "right",
  "& .MuiSvgIcon-root": {
    margin: 2,
  },
}));

export const OpenPairingSummary = (props: IOpenPairingSummaryProps): JSX.Element => {
  const { shortId, pairingId, crewId, path, isBidPairing } = props;
  const dispatch = useDispatch();

  const openPairingSummary = (): void => {
    dispatch(
      openWindow(`${shortId} Summary`, "PairingSummaryWindow", path, { pairingId, crewId, isBidPairing }, null, true)
    );
  };

  return (
    <OCOpenPairingSummary id="popout_pairing_summary_btn" onClick={openPairingSummary}>
      Open Summary
      <OpenInNewIcon />
    </OCOpenPairingSummary>
  );
};
